<template>
  <div>
    <!-- {{data}}{{planTime}} -->
    <!-- {{isReported}}/{{isAllPlan}}/{{isAllStoresReported}} -->
    <div class="tabs-bar" v-loading="loading">
      <!-- active 显示  reporting 默认提报  disabled 禁用 -->
      <div :class="`tabs-item ${planTime === `${item.dateTime.substring(0,4)}-${item.dateTime.substring(4)}` ? 'active' : ''}`"
        v-for="(item, index) in monthData"
        :key="index"
        @click="handleTabsClick(item)">
        <span>{{item.monthNum}}月</span>
        <!-- <span class="iconfont" :class="`icon-dengji-${item.grade}`" v-if="item.grade"></span> -->
      </div>
    </div>
  </div>
</template>

<script>
  // import mixin from '@/views/preSalePlan/utils/mixin.js'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  model: {
    prop: 'time',
    event: 'input'
  },
  props: ['time', 'data'],
  // mixins: [mixin],
  data() {
    return {
      planTime: null,
      // 月份数据
      monthData: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      //是否已提报
      isReported: 'isReported'
    }),
    activeMonth_set: {
      get() {
        return '';
      },
      async set(item) {
        let planTime = `${item.dateTime.substring(0,4)}-${item.dateTime.substring(4)}`;
        this.updatePlanTime(planTime);
        await this.updateIsAllReported();
        this.updateReportNum(item.isSub);
        this.reloadTabsBar();
      }
    }
  },
  mounted() {
    this.addListener_refresh();
    this.init();
  },
  methods: {
    addListener_refresh() {
      this.$bus.$off('monthRefresh');
      this.$bus.$on('monthRefresh', _=>{
        this.$nextTick(_=>{
          this.init();
        })
      });
    },
    // 月份分数
    async init() {
      this.loading = true;
      let data = {
        planTime: this.data.year,
        storeId: this.data['storeId']
      };
      let res = await this.$q.preSalePlan.planProductGrade({data})
      if(res.success && res.data) {
        this.monthData = res.data;
        let thisMonth = new Date().getMonth() + 1;
        // 不存在planTime，默认展示当月数据
        let item;
        if(!this.planTime) {
          item = res.data[thisMonth - 1];
        }else{
          item = res.data.filter(v=>v.dateTime == this.planTime.split('-').join(''))[0];
        }
        // 不是本年，默认展示1月份
        if(this.data.year !== new Date().getFullYear()) {
          item = res.data[0];
        }
        this.activeMonth_set = item;
      }else{
        this.monthData = [];
      }
      this.loading = false;
    },
    // tabs click
    handleTabsClick(item) {
      if(!item.isMaySub && !item.isSub) {
        this.$message({
          type: 'warning',
          message: `暂时不能提报${item.dateTime}的计划！`
        });
        return;
      }
      let planTime = `${item.dateTime.substring(0,4)}-${item.dateTime.substring(4)}`;
      this.activeMonth_set = item;
      this.$emit('change', planTime);
    },
    // 更新planTime
    updatePlanTime(data) {
      this.planTime = data;
      this.$emit('input', data);
      this.$store.dispatch('preSalePlan/set_planTime', data);
    },
    // 更新isReported(是否已提报)
    updateReportNum(status) {
      this.$store.dispatch('preSalePlan/get_reportNum', status);
    },
    // 更新isAllReported(全平台是否已提报)
    updateIsAllReported(status) {
      this.$store.dispatch('preSalePlan/get_isAllReported');
    },
    // 初始化tabsBar
    reloadTabsBar() {
      this.$nextTick(_=>{
        this.$bus.$emit('tabsBarReload',null);
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tabs-bar
    width 100%
    height auto 
    display flex
    justify-content flex-start
    align-items center
    margin-top 10px
    border-bottom 1px solid #eeeeee
    .tabs-item
      flex 1
      text-align center
      height 32px
      background #ffffff
      line-height 32px
      color #444
      position relative
      cursor pointer
      transition all linear .2s
      &:hover
        background rgb(240, 249, 235)
      &.active::after
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        content ""
        border-top 2px solid #67C23A
      &.reporting::before
        position absolute
        content ""
        width 8px
        height 8px
        border-radius 50%
        background-color red
        left 10px
        top 50%
        transform translate(0,-50%)
    .tabs-item+.tabs-item
      border-left 1px solid #eeeeee

  .iconfont
    font-size 18px
    position relative
    top 2px
    &[class*=A]
      color #67C23A
    &[class*=B]
      color #E6A23C
    &[class*=C]
      color #F56C6C
</style>